var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"healthbar"},[_c('div',{staticClass:"healthbar-fill",style:(_vm.charHealthStyle)}),_c('span',{staticClass:"healthbar-text"},[_vm._v(_vm._s(_vm.character.health))])])}
var staticRenderFns = []

export { render, staticRenderFns }